import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light" }, "Student Age Group List")
  ])
], -1)
const _hoisted_2 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Gender", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-md-2 mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "row col-12"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Summary of Trainees by age group", -1)
const _hoisted_24 = { class: "table-responsive mt-3" }
const _hoisted_25 = { class: "table table-borderless table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-transform":"uppercase","text-align":"center"},
      class: "w-100px text-center align-middle border border-gray-200"
    }, " Age (15-20) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-100px text-center align-middle border border-gray-200",
      style: {"text-transform":"uppercase","text-align":"center"}
    }, " Age (21-25) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-transform":"uppercase","text-align":"center"},
      class: "w-100px text-center align-middle border border-gray-200"
    }, " Age (26-30) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-transform":"uppercase","text-align":"center"},
      class: "w-100px text-center align-middle border border-gray-200"
    }, " Age (31-35) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-transform":"uppercase","text-align":"center"},
      class: "w-100px text-center align-middle border border-gray-200"
    }, " Age (36-40) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-transform":"uppercase","text-align":"center"},
      class: "w-100px text-center align-middle border border-gray-200"
    }, " Age (41-45) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-transform":"uppercase","text-align":"center"},
      class: "w-100px text-center align-middle border border-gray-200"
    }, " Age (46-50) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-transform":"uppercase","text-align":"center"},
      class: "w-100px text-center align-middle border border-gray-200"
    }, " Age (>80) ")
  ])
], -1)
const _hoisted_27 = { style: {} }
const _hoisted_28 = { class: "border border-gray-200 text-center text-primary fw-bolder" }
const _hoisted_29 = { class: "row col-12" }
const _hoisted_30 = {
  key: 0,
  class: "row mt-1 w-100 m-0"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Trainee List")
  ])
], -1)
const _hoisted_32 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_40 = {
  key: 1,
  class: "row"
}
const _hoisted_41 = {
  class: "col-md-12 mt-4",
  id: "dataTable"
}
const _hoisted_42 = { class: "row" }
const _hoisted_43 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_44 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[18] || (_cache[18] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "card mb-5 mb-xl-10",
        key: _ctx.componentKey
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      options: _ctx.optionsTPartner,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Training Partner",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.batch.institute_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.courseInfo()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (inst) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: inst.id,
                            label: inst.institute_name,
                            value: inst.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(inst.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      "collapse-tags": "",
                      placeholder: "Select Course",
                      modelValue: _ctx.batch.course_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (course) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: course.id,
                            label: course.course_name,
                            value: course.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(course.course_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Gender",
                      modelValue: _ctx.batch.gender,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.gender) = $event)),
                      style: {"width":"100%"},
                      onChange: _ctx.btnCheckStatus
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "male",
                          label: "Male"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Male")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "female",
                          label: "Female"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Female")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.agewiseCount())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_21
                    ])
                  ])
                ]),
                (_ctx.showTableData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("table", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("tbody", _hoisted_27, [
                            _createElementVNode("tr", _hoisted_28, [
                              _createElementVNode("td", {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getAgeRangeTrainee(15, 20))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_15_to_20), 1),
                              _createElementVNode("td", {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getAgeRangeTrainee(21, 25))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_21_to_25), 1),
                              _createElementVNode("td", {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getAgeRangeTrainee(26, 30))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_26_to_30), 1),
                              _createElementVNode("td", {
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getAgeRangeTrainee(31, 35))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_31_to_35), 1),
                              _createElementVNode("td", {
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getAgeRangeTrainee(36, 40))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_36_to_40), 1),
                              _createElementVNode("td", {
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getAgeRangeTrainee(41, 45))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_41_to_45), 1),
                              _createElementVNode("td", {
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getAgeRangeTrainee(46, 50))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_46_to_50), 1),
                              _createElementVNode("td", {
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getAgeRangeTrainee(51, 80))),
                                class: "cursor-pointer"
                              }, _toDisplayString(_ctx.count.age_under_80), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.showDetailsTrainee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                            title: "Download Xlse",
                            "data-v-54b12dc8": "",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.exportTrainee()))
                          }, _hoisted_34),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Download PDF",
                            "data-v-54b12dc8": "",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.downloadPdf()))
                          }, _hoisted_36),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Print",
                            "data-v-54b12dc8": "",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.printPdf()))
                          }, _hoisted_38),
                          _hoisted_39
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showDetailsTrainee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            (_openBlock(), _createElementBlock("div", {
                              key: _ctx.componentTableKey,
                              class: "card-body p-6",
                              "data-v-71816626": "",
                              style: {"border-radius":"1em","border":"2px solid #8dcb8d"}
                            }, [
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_Datatable, {
                                  "table-data": _ctx.tableData,
                                  "table-header": _ctx.tableHeader,
                                  "enable-items-per-page-dropdown": true
                                }, {
                                  "cell-tranche": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.tranche_info?.label), 1)
                                  ]),
                                  "cell-entity": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.entity_info?.entity_short_name), 1)
                                  ]),
                                  "cell-photo": _withCtx(({ row: industry }) => [
                                    _createElementVNode("img", {
                                      style: {"width":"50%"},
                                      src: 
                                  _ctx.apiUrl + industry?.attach_file_info?.file_path
                                ,
                                      alt: ""
                                    }, null, 8, _hoisted_44)
                                  ]),
                                  "cell-institute_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.institute_info?.short_name), 1)
                                  ]),
                                  "cell-reg_number": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.registration_number), 1)
                                  ]),
                                  "cell-mobile": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.mobile), 1)
                                  ]),
                                  "cell-name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_name), 1)
                                  ]),
                                  "cell-nid": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.nid), 1)
                                  ]),
                                  "cell-bcn": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.bcn), 1)
                                  ]),
                                  "cell-gender": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.gender), 1)
                                  ]),
                                  "cell-present_add": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.present_address), 1)
                                  ]),
                                  "cell-present_city": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.present_district_info
                                  ?.district_name_eng), 1)
                                  ]),
                                  "cell-postCode": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.present_post_code), 1)
                                  ]),
                                  "cell-present_district": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.present_district_info
                                  ?.district_name_eng), 1)
                                  ]),
                                  "cell-batch_number": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.batch_info?.batch_sequence_number), 1)
                                  ]),
                                  "cell-email": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.email), 1)
                                  ]),
                                  "cell-active_status": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry.active_status ? 'Active' : 'Inactive'), 1)
                                  ]),
                                  _: 1
                                }, 8, ["table-data", "table-header"])
                              ])
                            ]))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}